import { saas } from '../supabaseClient';

const PIN_RPC_MISSING_CODES = new Set(['42883', 'PGRST202']);

const getPinDeviceContext = (scope) => {
  if (typeof window === 'undefined') return { pin_scope: scope };

  return {
    pin_scope: scope,
    route: window.location?.pathname || '',
    userAgent: window.navigator?.userAgent || '',
    platform: window.navigator?.platform || '',
    language: window.navigator?.language || '',
    screen: {
      width: window.screen?.width || null,
      height: window.screen?.height || null,
    },
    restaurantName: window.localStorage?.getItem('currentRestaurantName') || '',
  };
};

export const verifyStaffPin = async (pin, {
  staffId = null,
  kitchenOnly = false,
  scope = 'staff_pin',
} = {}) => {
  const restaurantId = localStorage.getItem('currentRestaurantId');
  const cleanPin = String(pin || '').trim();

  if (!restaurantId || !cleanPin) return null;

  try {
    const params = {
      p_pin: cleanPin,
      p_staff_id: staffId,
      p_kitchen_only: kitchenOnly,
      p_scope: scope,
      p_device_context: getPinDeviceContext(scope),
    };

    let { data, error } = await saas.rpc('verify_staff_pin', params);

    if (error && PIN_RPC_MISSING_CODES.has(error.code)) {
      const legacy = await saas.rpc('verify_staff_pin', {
        p_pin: cleanPin,
        p_staff_id: staffId,
        p_kitchen_only: kitchenOnly,
      });
      data = legacy.data;
      error = legacy.error;
    }

    if (error) throw error;
    return Array.isArray(data) ? data[0] || null : data || null;
  } catch (err) {
    if (PIN_RPC_MISSING_CODES.has(err.code)) {
      throw new Error(`Secure PIN verification RPC call failed: ${err.message}. Check function signature/cache and active tenant context.`);
    }
    throw err;
  }
};
